<template>
<!--此部分根据设计自动生成，手动修改节点标记daltag="manual"属性，则该节点及子节点不会被自动生成代码覆盖，如发现其他需要调整框架情形请联系:alex.c@daline.com.cn-->
<div id="Productmanageroperationproject" style="width:100vw">
  <div id="aa8033ae">
    运营中列表
  </div>
  <el-table id="a098e273" :data="tbd_a098e273" stripe="" border="">
    <el-table-column prop="aade4eb5" label="项目名称">
    </el-table-column>
    <el-table-column prop="a0b62d4b" label="客户名称">
    </el-table-column>
    <el-table-column prop="cc32746d" label="产品经理">
    </el-table-column>
    <el-table-column prop="a8fd2e69" label="项目经理">
    </el-table-column>
    <el-table-column prop="a668ee5a" label="上线时间">
    </el-table-column>
    <el-table-column prop="ad94ac9f" label="七天日均在线">
    </el-table-column>
    <el-table-column prop="a1b9c7f1" label="运营时长">
    </el-table-column>
    <el-table-column prop="c5ed6c71" label="故障次数及时长">
    </el-table-column>
  </el-table>
  <el-pagination id="bb28dac6">
  </el-pagination>
</div>
</template>
<script>
//此文件根据设计自动生成编写框架，请在指定位置编写逻辑代码，如发现框架需要调整的情形请联系:alex.c@daline.com.cn
//在此注释下方添加自定义import
//在此注释下方添加自定义函数
//此注释下方为自动引用部分，请不要修改
export default{
  data(){
    return{
    tbd_a098e273:[]
      //在此注释下方添加自定义变量
    }
  },
  mounted(){
  },
  computed:{
  },
  watch:{
  },
  methods:{
    //在此注释下方添加自定义函数或事件
  }
}
</script>
<style>
/*此部分根据设计自动生成，自定义样式追加到该部分结尾处*/
#aa8033ae{
  padding-top:100px;
}
#aa8033ae{
  text-align:center;
  color:#1c1c1c;
  font-size:30px;
  font-family:PingFang SC;
}
#a098e273{
  width:1323px;
  margin-top:30px;
  margin-left:163px;
}
#a098e273{
  display:inline-block;
  vertical-align: middle;
}
#bb28dac6{
  width:302px;
  margin-top:60px;
  padding-left:673px;
  padding-bottom:1492px;
}
/*在此注释下方添加自定义样式*/
</style>
